import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpClient,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, BehaviorSubject, throwError } from "rxjs";
import { tap, switchMap, filter, take, catchError, finalize } from "rxjs/operators";
import { Router } from "@angular/router";
import { MastersKeyStringValue } from "../services/Non-Master/MastersKeyStringValue.service";

import { TranslateService } from "@ngx-translate/core";
import { LoggerService } from "src/app/services/Non-Master/logger.service";
import { ApiResultDialogService } from "src/app/services/Non-Master/ApiResultDialog.service";
import { AppSettings } from "../shared/AppSettings";
import { UserService } from "../shared/user.service";
import * as jwt_decode from "jwt-decode";
import * as _moment from "moment";
import { TokenModel } from "src/app/models/token-model/tokenModel";
import { NavigationComponent } from "../pages/navigation/navigation.component";
import { compensateScroll } from "@fullcalendar/core/util/misc";
const moment = _moment;

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  TAG = "AuthInterceptor";

  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  baseurl: string = AppSettings.BaseURI;
  readonly pathName_RefreshToken = "/ApplicationUser/RefreshToken";

  isAllowCheckToken = true;

  countGetToken = 0;

  blacklist = [
    "tVerModels",
    "ApplicationUser",
    "SimpleConfig",
    "UnitMediStockModel",
    "tMediConvModels",
    "FormMapping",
    "Shop",
  ];

  refreshTokenMinute = 15;

  constructor(
    private router: Router,
    private translate: TranslateService,
    private log: LoggerService,
    private userService: UserService,
    private apiResultDialogService: ApiResultDialogService,
    private http: HttpClient
  ) {}

  addTokenToRequest(req: HttpRequest<any>) {
    const clonedReq = req.clone({
      headers: req.headers.set(
        "Authorization",
        "Bearer " + localStorage.getItem("token")
      ),
    });
    return clonedReq;
  }

  refreshTokenInProgress = false;

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (localStorage.getItem("token") != null) {
      //Should refresh token ?
      if (this.shouldRefreshToken(req) && this.isNotRefreshTokenApi()) {
        //refreshTokenInProgress ： is updating the token ? ture = another http request will not be call refreshToken API
        if (!this.refreshTokenInProgress) {
          this.refreshTokenInProgress = true;
          this.refreshTokenSubject.next(null); //  refreshTokenSubject = null , will stop to send this http requset
          // after get new token , use new token to send http request
          return this.userService
            .changeShopID(NavigationComponent.selectedShopID)
            .pipe(
              switchMap((resp: any) => {
                localStorage.setItem("token", resp.token);
                localStorage.setItem(
                  "tokenLastModify",
                  new Date().getTime().toString()
                );
                this.refreshTokenSubject.next(resp.token);
                return next.handle(this.addTokenToRequest(req));
              }),
              catchError((errorRes) => throwError(errorRes)),
              finalize(() => {
                this.refreshTokenInProgress = false; // finally must set refreshTokenInProgress = false . if no set , will stop further http requset to send
              })
            );
        }else{
            return this.refreshTokenSubject.pipe(
                filter(result => result !== null), //filter handle to send the further http request to server when calling the refresh token API
                take(1),
                switchMap(() => {return next.handle(this.addTokenToRequest(req)).pipe(tap(succ=>{},err=>{this.handleError(err)}));
                })
            );
        }
      } else {
        return next.handle(this.addTokenToRequest(req)).pipe(tap(succ=>{},err=>{
            this.handleError(err);
        }));

      }

      //   if (!this.isRefreshing) {
      //     if (this.isRefreshToken(req)) {
      //       this.isRefreshing = true;
      //       this.service.changeShopID(NavigationComponent.selectedShopID).pipe(
      //         switchMap((token: any) => {
      //           this.isRefreshing = false;
      //           localStorage.setItem("token", token.token);
      //           return next.handle(this.addTokenToRequest(req));
      //         }));
      //     } else {
      //       return next.handle(this.addTokenToRequest(req));
      //     }
      //   }

      //return next.handle(clonedReq).pipe(
      //       tap(
      //           succ => {
      //               //refresh token if token will be expire
      //               if(!clonedReq.url.includes("assets")){
      //                   if (this.isAllowCheckToken && this.isAllowUrl(clonedReq.url)) this.getNewToken();
      //               }
      //               //console.log('@768 http said hello');
      //           },
      //           err => {

      //               let returnDisplayMsg: string;

      //              // this.log.i(this.TAG, 'returnDisplayMsg1 = ' + returnDisplayMsg);
      //              this.log.i(this.TAG,"status code = "+err.status);
      //              console.log(err);

      //               if (err.status === 401) {

      //                //   this.log.i(this.TAG,err.message);
      //                this.log.i(this.TAG,"status code = "+err.status);

      //                   this.log.i(this.TAG,err.status);
      //                   this.log.i(this.TAG,err.message);

      //                   if(err.error!=null &&err.error!="" &&err.error.length<50){
      //                       returnDisplayMsg = err.error;
      //                   }

      //                   //get login fail result
      //                   this.apiResultDialogService.CheckUnauthorizedReason(localStorage.getItem('token'));

      //                   this.translate.get('Message_ForceLogout').subscribe((res: string) => {
      //                       returnDisplayMsg = res;
      //                       this.removeToken();
      //                   });

      //               }else if (err.status === 403) {
      //                  // this.removeToken();
      //                    returnDisplayMsg = "失敗"+"<br>"+"Error Code : "+err.status+"<br>權限不足<br>";
      //                    if(err.error!=null &&err.error!="" &&err.error.length<50){
      //                       returnDisplayMsg += err.error;
      //                   }

      //                    this.removeToken();

      //               }
      //                else if (err.status === 0) {
      //                   this.translate.get('Message_ForceLogout_exception').subscribe((res: string) => {
      //                       returnDisplayMsg = res;
      //                   });
      //               }else {
      //                   // returnDisplayMsg = "失敗"+" - 請重試/聯絡系統職員<br>"+"Error Code : "+err.status+"<br>";
      //                   returnDisplayMsg = "失敗"+"<br>"+"Error Code : "+err.status+"<br>";

      //                   try{

      //                       var errorMsg = "";
      //                       if (err.error instanceof Error) {
      //                           // A client-side or network error occurred. Handle it accordingly.
      //                           console.error('An error occurred:', err.error.message);
      //                           errorMsg = err.error.message;
      //                         } else {
      //                           // The backend returned an unsuccessful response code.
      //                           // The response body may contain clues as to what went wrong,
      //                           console.error(`Backend returned code ${err.status}, body was: ${err.error}`);
      //                           errorMsg = err.error;

      //                         }

      //                       if(errorMsg.length < 100){
      //                           returnDisplayMsg+= errorMsg;
      //                       }

      //                   }catch(e){
      //                       console.log(e);
      //                   }
      //               }

      //              // this.log.i(this.TAG, 'returnDisplayMsg2 = ' + returnDisplayMsg +" , this.apiResultDialogService.CheckApiResultDialogOpen() = "+this.apiResultDialogService.CheckApiResultDialogOpen());

      //               if (this.apiResultDialogService.CheckApiResultDialogOpen() === false) {
      //                   this.openAPI_Result_Modal(MastersKeyStringValue.STATUS_SUCCESS, returnDisplayMsg);
      //               }

      //           }
      //       )
      //   );
    } else {
      return next.handle(req.clone());
    }
  }

  handleError(e){
    let returnDisplayMsg = '';
    // console.error(e);

    console.warn('UserAuth Status = '+ e.status + ' , msg = '+ e.message);

    if(e.status == 401){
        if(e.error!=null &&e.error!="" &&e.error.length<50){
            returnDisplayMsg = e.error;
        }else{
            this.apiResultDialogService.CheckUnauthorizedReason(localStorage.getItem('token'));

            this.translate.get('Message_ForceLogout').subscribe((res: string) => {
                returnDisplayMsg = res;
                this.removeToken();
            });
        }

    }else if(e.status == 403){
        returnDisplayMsg = "失敗"+"<br>"+"Error Code : "+e.status+"<br>權限不足<br>";
        if(e.error!=null &&e.error!="" &&e.error.length<50){returnDisplayMsg += e.error;}
    }else if(e.status == 0){
        this.translate.get('Message_ForceLogout_exception').subscribe((res: string) => {returnDisplayMsg = res;});
    }else{
        returnDisplayMsg = "失敗"+"<br>"+"Error Code : "+e.status+"<br>";
        try {
          let errorMsg = "";
          if (e.error instanceof Error) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error("An error occurred:", e.error.message);
            errorMsg = e.error.message;
          } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
              `Backend returned code ${e.status}, body was: ${e.error}`
            );
            errorMsg = e.error;
          }

          if (errorMsg.length < 100) {
            returnDisplayMsg += errorMsg;
          }
        } catch (e) {
          console.log(e);
        }
    }


    //display dialog
    if (!this.apiResultDialogService.CheckApiResultDialogOpen()) {
        this.openAPI_Result_Modal(MastersKeyStringValue.STATUS_SUCCESS, returnDisplayMsg);
    }
  }

  removeToken() {
    localStorage.removeItem("token");
    this.router.navigateByUrl("/login");
  }

  openAPI_Result_Modal(status, msg) {
    this.log.i(
      this.TAG,
      "openConfirmModal action = " + MastersKeyStringValue.ACTION_MessageDialog
    );
    this.apiResultDialogService.openDialog(
      MastersKeyStringValue.ACTION_MessageDialog,
      "",
      status,
      msg
    );
  }

  private handleToken(req: HttpRequest<any>, next: HttpHandler) {
    // this.log.i(this.TAG,"token = " + 'handletoken');

    return this.refreshToken().pipe(
      switchMap((token: any) => {
        this.isRefreshing = false;
        this.refreshTokenSubject.next(token.jwt);
        return next.handle(req);
      })
    );

    // if (!this.isRefreshing) {
    //   this.isRefreshing = true;
    //   this.refreshTokenSubject.next(null);

    //   return this.refreshToken().pipe(
    //     switchMap((token: any) => {
    //       this.isRefreshing = false;
    //       this.refreshTokenSubject.next(token.jwt);
    //       return next.handle(req.clone());
    //     }));

    // } else {
    //   return this.refreshTokenSubject.pipe(
    //     filter(token => token != null),
    //     take(1),
    //     switchMap(jwt => {
    //       return next.handle(req.clone());
    //     }));
    // }
  }

  refreshToken() {
    // this.log.i(this.TAG,"token = " + 'refreshtoken: ' + this.baseurl + this.pathName_RefreshToken);
    return this.http
      .post<any>(this.baseurl + this.pathName_RefreshToken, {
        token: this.getRefreshToken(),
      })
      .pipe(
        tap((tokens: any) => {
          // this.log.i(this.TAG,"token = " + 'refreshtokenResult');

          this.storeJwtToken(tokens.token);
        })
      );
  }

  private storeJwtToken(jwt: string) {
    this.log.i(this.TAG, "token = " + "StoretokenResult: " + jwt);
    localStorage.setItem("token", jwt);
  }

  private getRefreshToken() {
    return localStorage.getItem("token");
  }

  isNotRefreshTokenApi(){
    return true;
  }

  shouldRefreshToken(req: HttpRequest<any>) {
    if (!req.url.includes("assets")) {
      if (this.isAllowCheckToken && this.isAllowUrl(req.url)) {
        if (localStorage.getItem("token") != null) {
          const tokenInfo = this.getDecodedAccessToken(
            localStorage.getItem("token")
          ); // decode token
          const token: TokenModel = tokenInfo;

          let now: Date = new Date();
          let exp = new Date(token.exp * 1000);
          //console.log('@13 old exp = '+token.exp)
          //console.log("@01 token exprie time = " + exp + " , now = " + now);

          if (exp < now) {
            //console.log("token exprie time < now");
            this.isAllowCheckToken = true;
          } else if (exp == now) {
            //console.log("token exprie time == now");
            this.isAllowCheckToken = true;
          } else {
            //console.log("token exprie time > now");
            let exp2 = moment(exp)
              .subtract(this.refreshTokenMinute, "m")
              .toDate();
            if (exp2 > now) {
              // console.log(
              //   "token exprie time - " +
              //     this.refreshTokenMinute +
              //     "mins =" +
              //     exp2
              // );
              // console.log(
              //   "token exprie time - " + this.refreshTokenMinute + "mins > now"
              // );
              this.isAllowCheckToken = true;
            } else {
              // console.log(
              //   "@1001 token exprie time - " +
              //     this.refreshTokenMinute +
              //     "mins < now"
              // );
              // console.log("**** refresh token ****");
              return true;
            }
          }
        }
      }
    }

    return false;
  }

  getNewToken() {
    this.countGetToken++;
    console.log("getNewToken checking count = " + this.countGetToken);
    this.isAllowCheckToken = false;
    //exp < now -> logout
    if (localStorage.getItem("token") != null) {
      const tokenInfo = this.getDecodedAccessToken(
        localStorage.getItem("token")
      ); // decode token
      const token: TokenModel = tokenInfo;

      let now: Date = new Date();
      let exp = new Date(token.exp * 1000);
      //console.log('@13 old exp = '+token.exp)
      console.log("@01 token exprie time = " + exp + " , now = " + now);

      if (exp < now) {
        console.log("token exprie time < now");
        this.isAllowCheckToken = true;
      } else if (exp == now) {
        console.log("token exprie time == now");
        this.isAllowCheckToken = true;
      } else {
        console.log("token exprie time > now");
        let exp2 = moment(exp).subtract(this.refreshTokenMinute, "m").toDate();
        if (exp2 > now) {
          console.log(
            "token exprie time - " + this.refreshTokenMinute + "mins =" + exp2
          );
          console.log(
            "token exprie time - " + this.refreshTokenMinute + "mins > now"
          );
          this.isAllowCheckToken = true;
        } else {
          console.log(
            "@1001 token exprie time - " +
              this.refreshTokenMinute +
              "mins < now"
          );
          console.log("@1001 refresh token");
          this.userService
            .changeShopID(NavigationComponent.selectedShopID)
            .subscribe(
              (res: any) => {
                localStorage.setItem("token", res.token);
                this.isAllowCheckToken = true;
                this.countGetToken = 0;
              },
              (err) => {
                console.log(err);
                this.isAllowCheckToken = true;
                this.countGetToken = 0;
              }
            );
        }
      }
    }
  }

  getDecodedAccessToken(token: string): any {
    try {
      return jwt_decode(token);
    } catch (Error) {
      return null;
    }
  }

  isAllowUrl(url: String) {
    if (!this.blacklist.includes(url.split("/api/")[1].split("/")[0]))
      //console.log("accepted url : " + url.split("/api/")[1]);
    return !this.blacklist.includes(url.split("/api/")[1].split("/")[0]);
  }
}
